/* eslint-disable max-len, no-await-in-loop, no-new, no-unused-vars, padded-blocks */
/* eslint no-shadow: ["error", { "allow": ["state"] }] */
import api from '@/api';

export const namespaced = true;

export const state = {
  errorMessage: null,
  pricelistEntries: null,
};

export const actions = {
  async getPricelistEntries({ commit }, id) {
    await api.get(`/pricelist/${id}/pricelistentry`).then(async (response) => {
      commit('SET_PRICELISTENTRIES', response.data);
    }).catch((exception) => {
      console.error(exception);
      commit('SET_ERROR_MESSAGE', exception);
    });
  },
};

export const mutations = {
  SET_ERROR_MESSAGE(state, errorMessage) {
    state.errorMessage = errorMessage;
  },
  SET_PRICELISTENTRIES(state, data) {
    state.pricelistEntries = data;
  },
};
